import intersect from 'turf-intersect';
const polygon = require('turf-helpers').polygon;
import { createNewArray } from '../roofsSelectorClassicDesigner/roofsSelectorClassicDesigner';
import { dispatch, state } from '__common/store';
import { OPEN_CONFIRM_CLEAR_ARRAYS_MODAL, SET_LOCATION, HIDE_CURSOR, SHOW_CURSOR, OPEN_DRAWER_PAGE } from 'actions';

import {
  deleteAllBingShapes,
  getBingRoofOver,
  makeBingRoofEmpty,
  removeBingShape,
  toogleBingRoofSelection,
  redrawBingRoofs,
  goToBingPanelsEditor,
  turnOffBingEditing,
  } from '__editor/bingMapsRoofsSelector/components/bingMapsRoofsSelectorDrawingManager/bingMapsRoofsSelectorDrawingManager';
import {
  deleteAllGoogleRoofs,
  deleteGoogleRoof,
  getGoogleRoofOver,
  makeGoogleRoofEmpty,
  selectGoogleRoof,
  redrawGoogleRoofs,
  goToGooglePanelsEditor,
  } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManager';
import { clearLastZipCode } from '../roofsSelectorMap/roofsSelectorMapEpic';
import { clearAutoSaveProjectTimeout } from '../roofsSelectorSaveLoadProject/saveProject';
import { REMOVE_ROOF_OBSTRUCTIONS, SET_RELOCATION_ACTIVE } from '__editor/panelsEditor/actions';
import { isBlankMap, isGoogleMap } from '__common/constants/map';
import { isCommercialProduct, isEcoFoot2Plus, isRMGridFlex, isSMTiltPR, isAscender, isResidentialProduct, isRMIFIProduct } from '__common/constants/products';
import { RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS } from 'projectDesign/components/projectConfiguration/utils/updateProjectOption';
import { checkFieldNotEmpty } from '../roofsSelectorSaveLoadProject/utils/validateProject';
import { isASCE716or722 } from '__common/constants/buildingCodes';
import { apiField as buildingHeightApiField } from 'projectDesign/components/projectConfiguration/fields/buildingHeight';
import { distanceCheckFromFirstRoofCenter, distanceErrorMessage } from '__editor/googleMapsRoofsSelector/components/drawingManager/utils/roofSizeAlert';
import { apiField as longestBuildingLengthApiField } from 'projectDesign/components/projectConfiguration/fields/longestBuildingLength';
import { apiField as shortestBuildingLengthApiField } from 'projectDesign/components/projectConfiguration/fields/shortestBuildingLength';
import { LOCATION_AND_LOADS_PAGE, RAIL_SYSTEM_PAGE } from 'projectDesign/components/projectConfiguration/utils/projectConfigurationDrawerPages';
import { apiField as buildingCodeApiField } from 'projectDesign/components/projectConfiguration/fields/buildingCode';
import { roofPitchUpdate } from "__common/utils/versionCompare/versionCompare";

let editorWidth;
let editorHeight;
let panelsInteractionBlockTimeout;
const panelsInteractionBlockTimeoutTime = 500;

export let panelsInteractionBlock = false;

export function setEditorDims(width, height) {
  editorHeight = height;
  editorWidth = width;
}

export function getEditorDims() {
  return {
    width: editorWidth,
    height: editorHeight,
  };
}

// Remove: once roof pitch 1/12 is available for 716
export function clearRoofsWhenAsce716Or722IsEnabled(currentBuildingCode) {
  const {  drawingManager: { roofs }, projectConfiguration: { projectVersion, projectEnvConfig : { tilt }, productId } } = state();
  
  if(isASCE716or722(currentBuildingCode)) { 
    if (roofs && Object.keys(roofs).length) {
      Object.keys(roofs).map(roofId => {
        if(roofPitchUpdate(projectVersion) ? ['1', '2', '3', '4', '5', '6', '7', '8'].includes(roofs[roofId].roofPitch) : roofs[roofId].roofPitch === '1/12') {
          makeRoofEmpty(Number(roofId)); 
        }
      });
    }
  }
}


export function clearRoofsFromMap() {
  const { drawingManager: { roofs }, roofsSelector: { mapType } } = state();
  if (roofs && Object.keys(roofs).length > 0) {
    if (isGoogleMap(mapType)) {
      deleteAllGoogleRoofs();
    } else {
      deleteAllBingShapes();
    }
  }
}

export function getRoofOver() {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return getGoogleRoofOver();
  }

  return getBingRoofOver();
}

export function makeAllRoofsEmpty() {
  const { drawingManager: { roofs } } = state();

  if (roofs && Object.keys(roofs).length) {
    Object.keys(roofs).map(roofId => makeRoofEmpty(Number(roofId)));
  }
}

export function makeRoofEmpty(roofId: number) {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return makeGoogleRoofEmpty(roofId);
  }

  return makeBingRoofEmpty(roofId);
}

export function selectRoof(roofId: number) {
  const { roofsSelector: { mapType } } = state();
  if (isGoogleMap(mapType)) {
    return selectGoogleRoof(roofId);
  }

  return toogleBingRoofSelection(roofId);
}

export function deleteRoof(roofId: number) {
  const { roofsSelector: { mapType }, drawingManager: {roofs} } = state();
  const numberOfRoofAreas = Object.values(roofs)?.length;

  dispatch(REMOVE_ROOF_OBSTRUCTIONS(roofId));

  if (isGoogleMap(mapType)) {
    return deleteGoogleRoof(roofId);
  }

  removeBingShape(roofId);

  if (isBlankMap(mapType) && Number(roofId) === 1 && numberOfRoofAreas < 2) {
    createNewArray();
  }
}

export function clearRoof(marker: {lat:number, lng:number}, cb: () => void) {
  const { drawingManager: { roofs }, roofsSelectorMap: { location } } = state();
  let oldLocation = location;
  if (roofs && Object.keys(roofs).length > 0 && distanceCheckFromFirstRoofCenter(true, marker)) {
    dispatch(
      OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
        'Change roofarea location',
        'Changing roofarea location will remove all installations. Are you sure?',
        () => {
          clearRoofsFromMap();
          dispatch(SET_RELOCATION_ACTIVE(false));
          distanceErrorMessage(false);
          cb();
        },
        null,
        null,
        SET_LOCATION(oldLocation += ' '),
      ),
    );
  } else {
    cb()
  }
}

export function clearRoofWithWarning(cb: () => void) {
  const { drawingManager: { roofs }, roofsSelectorMap: { location } } = state();
  let oldLocation = location;
  if (roofs && Object.keys(roofs).length > 0) { 
    dispatch(
      OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
        'Change map location',
        'Changing map location will remove all installations. Are you sure?',
        () => {
          clearLastZipCode();
          clearRoofsFromMap();
          cb();
          dispatch(SET_RELOCATION_ACTIVE(false));
        },
        null,
        null,
        SET_LOCATION(oldLocation += ' '),
      ),
    );
  } else {
    clearLastZipCode();
    cb();
  }
}

// Two roofs that merely share an edge or a corner are NOT overlapping - turf's
// intersect() still returns a geometry for them (a LineString for a shared edge,
// a Point for a shared corner), and turf-overlaps (v1) likewise reports a false
// positive for edge/corner-only contact. Adjacent roofs created via corner
// snapping rely on these touches being allowed, so the decision is based purely
// on whether the intersection has real 2D AREA - a shared boundary has none.

// Planar shoelace area of a closed ring of [x, y] points. Units are arbitrary
// (here squared degrees); only used as a ratio so the unit cancels out.
function ringArea(ring): number {
  if (!ring || ring.length < 3) {
    return 0;
  }
  let area = 0;
  for (let i = 0; i < ring.length - 1; i++) {
    area += ring[i][0] * ring[i + 1][1] - ring[i + 1][0] * ring[i][1];
  }
  return Math.abs(area) / 2;
}

function geometryArea(geometry): number {
  if (!geometry) {
    return 0;
  }
  if (geometry.type === 'Polygon') {
    return ringArea(geometry.coordinates && geometry.coordinates[0]);
  }
  if (geometry.type === 'MultiPolygon') {
    return (geometry.coordinates || []).reduce((sum, poly) => sum + ringArea(poly && poly[0]), 0);
  }
  if (geometry.type === 'GeometryCollection') {
    return (geometry.geometries || []).reduce((sum, g) => sum + geometryArea(g), 0);
  }
  return 0; // LineString / Point / etc. -> shared boundary, no area
}

// Overlap is only "real" when the intersection area is a meaningful fraction of
// the smaller roof. This ignores both shared boundaries (zero area) and any
// sub-pixel slivers a lat/lng round trip might introduce on a snapped edge.
const OVERLAP_AREA_RATIO_THRESHOLD = 0.01;

export function newRoofOverlaping(newRoofsCoords: { lat: number; lng: number }[], roofId?: string) {
  const roofs = state().drawingManager.roofs;

  const newTurfPolyCords = newRoofsCoords.map(coord => {
    return [coord.lat, coord.lng];
  });

  newTurfPolyCords.push(newTurfPolyCords[0]);

  const newTurfPoly = polygon([newTurfPolyCords]);
  const newPolyArea = ringArea(newTurfPolyCords);

  if (!roofs || Object.keys(roofs).length === 0) {
    return false;
  }

  return Object.keys(roofs).some(roofName => {
    const roof = roofs[roofName];

    const turfPolyCords = roof.coords.map(coord => {
      return [coord.lat, coord.lng];
    });

    if (Number(roofName) === Number(roofId)) {
      return false;
    }

    turfPolyCords.push(turfPolyCords[0]);

    const turfPoly = polygon([turfPolyCords]);
    const existingPolyArea = ringArea(turfPolyCords);

    const intersection = intersect(turfPoly, newTurfPoly);
    const overlapArea = geometryArea(intersection && intersection.geometry);
    const smallerArea = Math.min(newPolyArea, existingPolyArea) || 1;

    return (overlapArea / smallerArea) > OVERLAP_AREA_RATIO_THRESHOLD;
  });
}

export function redrawRoof() {
  const { roofsSelector: { mapType } } = state();

  if (isGoogleMap(mapType)) {
    return redrawGoogleRoofs();
  }

  return redrawBingRoofs();
}

const openDrawerPage = (invalidFields) => {
  if (invalidFields.has(buildingCodeApiField) || invalidFields.has('zipcode')) {
    dispatch(OPEN_DRAWER_PAGE(LOCATION_AND_LOADS_PAGE));
  }
  else {
    dispatch(OPEN_DRAWER_PAGE(RAIL_SYSTEM_PAGE));
  }
}

export function canGotoPanelsEditor() {
  const { projectConfiguration: { productId, formState: { invalidFields: allInvalidFields }, projectEnvConfig } } = state();

  // restrict to go to panel editor if fields are empty/invalid which affect the setback/wind zone classification
  let invalidFields = new Set<string>();
  if (isRMGridFlex(productId) ) {
    if ( isRMGridFlex(productId) ) {
      RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.map(field =>  !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
      allInvalidFields.map(({ fieldName }) => RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.includes(fieldName) && invalidFields.add(fieldName));
    }
  }
  
  if (isCommercialProduct(productId) || isResidentialProduct(productId)){
    let DEFAULT_EMPTY_FIELDS = [buildingHeightApiField];

    if ( (isCommercialProduct(productId)  && !isRMIFIProduct(productId)) || isAscender(productId)   || isSMTiltPR(productId) ) {
      DEFAULT_EMPTY_FIELDS.push(longestBuildingLengthApiField);
    }
    
    if (isResidentialProduct(productId) || isEcoFoot2Plus(productId)) {
        DEFAULT_EMPTY_FIELDS.push(shortestBuildingLengthApiField);
    }

    DEFAULT_EMPTY_FIELDS.map(field =>  !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
    allInvalidFields.map(({ fieldName }) => DEFAULT_EMPTY_FIELDS.includes(fieldName) && invalidFields.add(fieldName));

    if(invalidFields.size){
      openDrawerPage(invalidFields);
      return false;
    }
  }
  
    const DEFAULT_EMPTY_FIELDS = [ 'zipcode' ];
    DEFAULT_EMPTY_FIELDS.map(field => !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
    allInvalidFields.map(({ fieldName }) => DEFAULT_EMPTY_FIELDS.includes(fieldName) && invalidFields.add(fieldName));
  
  if(invalidFields.size){
    openDrawerPage(invalidFields);
    return false;
  }
  return true;
}

export function goToPanelsEditor(roofInfo/* : google.maps.Polygon | Leaflet.LatLng */, roofId: number) {
  
  if (!canGotoPanelsEditor()) return;

  const { roofsSelector: { mapType } } = state();

  clearTimeout(panelsInteractionBlockTimeout);
  clearAutoSaveProjectTimeout();
  turnOffEditing();

  panelsInteractionBlock = true;
  
  dispatch(HIDE_CURSOR());
  
  if (isGoogleMap(mapType)) {
    goToGooglePanelsEditor(roofInfo, roofId);
    panelsInteractionBlockTimeout = setTimeout(
      () => { 
        panelsInteractionBlock = false; 
        dispatch(SHOW_CURSOR());
      }, 
      panelsInteractionBlockTimeoutTime);
    return;
  }

  goToBingPanelsEditor(roofInfo, roofId);
  panelsInteractionBlockTimeout = setTimeout(
    () => { 
      panelsInteractionBlock = false; 
      dispatch(SHOW_CURSOR());
    }, 
    panelsInteractionBlockTimeoutTime);
  return;
}

export function clearPanelsInteractionBlockTimeout() {
  clearTimeout(panelsInteractionBlockTimeout);
}

// Block panel creation for a short window after programmatically entering the
// panels editor. The legacy goToPanelsEditor wrapper sets this internally;
// callers that bypass that wrapper (e.g. UB-Lite's safeDeployRoof, which calls
// goToGooglePanelsEditor directly to skip the canGotoPanelsEditor gate) must
// invoke this so the trailing mouse-up from a double-click that finalized the
// roof doesn't land on the freshly-opened editor and drop a stray panel.
export function blockPanelsInteractionTemporarily() {
  clearTimeout(panelsInteractionBlockTimeout);
  panelsInteractionBlock = true;
  panelsInteractionBlockTimeout = setTimeout(
    () => { panelsInteractionBlock = false; },
    panelsInteractionBlockTimeoutTime);
}

function turnOffEditing() {
  const { roofsSelector: { mapType } } = state();

  if (isGoogleMap(mapType)) {
    // to be done someday;
    return;
  }

  return turnOffBingEditing();
}
